export const SELLER_ID_SAE = 'shop-apotheke'
